'use client';
import axios from 'axios';
import { useEffect, useState, lazy } from 'react';
import { Spinner } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import classes from './Components/GoogleReviewCard.module.css';
import SellerReviewsCard from './Components/SellersReviewCard';
import LineSeparator from '@/components/UI/LineSeparator';
import { useAlertContext } from '@/context/alert';

const GoogleReviewPage = () => {
	const [sellerReviews, setSellerReviews] = useState([]);
	const [getLoading, setGetLoading] = useState(false);

	const { SET_ALERT } = useAlertContext();

	const getSellerReviews = async () => {
		await axios
			.get(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/other/review/seller-all-reviews`
			)
			.then((res) => {
				setSellerReviews(res.data);
			})
			.catch((err) => {
				console.log(err);
				SET_ALERT({ msg: 'Error fetching review', type: 'danger' });
			});
		setGetLoading(false);
	};

	useEffect(() => {
		setGetLoading(true);
		getSellerReviews();
		// getGoogleReviews();
	}, []);

	const [reviewsNumber, setReviewsNumber] = useState(8);
	const showMoreHandler = () => {
		if (sellerReviews.reviews && reviewsNumber < sellerReviews.reviews.length) {
			setReviewsNumber(reviewsNumber + 8);
		}
	};

	const showLessHandler = () => {
		setReviewsNumber(8);
	};

	return (
		<div className={classes.reviewContainer}>
			<div className={classes.reviewCardContainer}>
				{getLoading && <Spinner animation="border" variant="primary" />}
				<h2 className={classes.reviewPageHeader}>Our customers say...</h2>
				<LineSeparator />
				<div className={classes.reviewCardParent}>
					{sellerReviews.reviews &&
						sellerReviews.reviews
							.sort((a, b) => new Date(b.order.date) - new Date(a.order.date))
							.slice(0, reviewsNumber)
							.map((review, i) => (
								<SellerReviewsCard review={review} key={i} />
							))}
				</div>
			</div>
			<div className={classes.showMoreContainer}>
				<button
					className={classes.showMore}
					onClick={
						sellerReviews.reviews &&
						reviewsNumber >= sellerReviews.reviews.length
							? showLessHandler
							: showMoreHandler
					}
				>
					{sellerReviews.reviews &&
					reviewsNumber >= sellerReviews.reviews.length
						? 'Show less reviews'
						: 'Read more reviews'}
				</button>
			</div>
		</div>
	);
};

export default GoogleReviewPage;
